import { render } from "./AuthNavbar.vue?vue&type=template&id=5fbe46c0"
import script from "./AuthNavbar.vue?vue&type=script&lang=js"
export * from "./AuthNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__